module.exports = __webpack_public_path__ + "img/IMG_5901.e88ef92c.jpg";